var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"Start with your dreams"}}),_c('vs-button',{on:{"click":function($event){return _vm.$router.push({ name: 'dreams' })}}},[_vm._v("\n    Create Your First Dream\n  ")]),_c('DreamsPreview',{staticClass:"mt-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }